import { apiClient } from "api/ApiClient";
import { EventType } from "pages/statuses/EventType";

/**
 * 予約一覧取得
 * @param startViewDate 表示開始日時（必須）
 * @param endViewDate 表示終了日時（必須）
 */
const getBooking = async (startViewDate: Date, endViewDate: Date): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking`, {
            startViewDate: startViewDate,
            endViewDate: endViewDate,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * 予約IDから予約取得(一件)
 * @param id 予約ID（必須）
 */
const getBookingForConfirm = async (id: number): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking/:id`, {
            id: id,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * 暗号化された予約IDから予約取得(一件)
 * @param id 予約ID（必須）
 */
const getBookingForConfirmByEncryptedId = async (id: string): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking/confirm/:id`, {
            id: id,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * 研究室に紐づく予約情報を取得
 * @param date 選択日時
 * @param subscriberLaboratoryId 研究室id
 */
const getBookingForLaboratoryCheck = async (date: Date, subscriberLaboratoryId: string | undefined): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking/laboratory_check`, { date, subscriberLaboratoryId });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * 予約枠が空いているかどうかチェック
 * @param start 予約開始日時
 * @param end 予約終了日時
 * @param bookingTypeId 予約種別ID
 */
const checkFree = async (start: Date, end: Date, bookingTypeId: number): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking/check_free`, {
            start: start,
            end: end,
            bookingTypeId: bookingTypeId,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * 予約者情報入力チェック
 * @param booking 予約情報
 */
const checkSubscriberInfo = async (booking: EventType): Promise<any> => {
    try {
        const response = await apiClient.post(`/booking/check_subscriber`, booking);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

/**
 * 廃液情報入力チェック
 * @param booking 予約情報
 */
const checkBookingDetail = async (booking: EventType): Promise<any> => {
    try {
        const response = await apiClient.post(`/booking/check_detail`, booking);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

/**
 * 予約情報登録
 * @param booking 予約情報
 */
const createBooking = async (booking: EventType): Promise<any> => {
    try {
        const response = await apiClient.post(`/booking`, booking);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

/**
 * 予約情報更新
 * @param booking 予約情報
 */
const updateBooking = async (booking: EventType): Promise<any> => {
    try {
        const response = await apiClient.put(`/booking`, booking);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

/**
 * 予約情報削除
 * @param id 予約ID
 * @param bookingTypeId 予約種別ID
 */
const deleteBooking = async (id: number, bookingTypeId: number | undefined): Promise<any> => {
    try {
        const response = await apiClient.delete(`/booking`, {
            id: id,
            bookingTypeId: bookingTypeId,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

/**
 * 大学基本情報取得
 */
const getUnivercityBasicInfo = async (): Promise<any> => {
    try {
        const response = await apiClient.get(`/booking/univercity_info`);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

export const BookingApi = {
    getBooking,
    getBookingForConfirm,
    getBookingForConfirmByEncryptedId,
    getBookingForLaboratoryCheck,
    checkFree,
    checkSubscriberInfo,
    checkBookingDetail,
    createBooking,
    updateBooking,
    deleteBooking,
    getUnivercityBasicInfo,
};
